import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";

import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
 
export default function data() {
  const avatars = (members) =>
    members.map(([image, name]) => (
      <Tooltip key={name} title={name} placeholder="bottom">
        <MDAvatar
          src={image}
          alt={name}
          size="xs"
          sx={{
            border: ({ borders: { borderWidth }, palette: { white } }) =>
              `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",
            "&:not(:first-of-type)": {
              ml: -1.25,
            },
            "&:hover, &:focus": {
              zIndex: "10",
            },
          }}
        />
      </Tooltip>
    ));

  const Ranking = ({ name }) => (
    <MDTypography variant="button" fontWeight="medium" lineHeight={1}>
      {name}
    </MDTypography>
  );

  return {
    columns: [
      { Header: "ranking", accessor: "ranking", width: "1%", align: "left" },
      {
        Header: "name",
        accessor: "name",
        width: "10%",
        align: "left",
        hidden: true,
        style: {
          color: "black",
        },
         
      },
      {
        Header: "view",
        accessor: "view",
        width: "10%",
        align: "left",
        hidden: true,
        style: {
          color: "black",
        },
      },
      {
        Header: "visitors",
        accessor: "visitors",
        width: "10%",
        align: "left",
        hidden: true,
        style: {
          color: "black",
        },
      },
      {
        Header: "amount",
        accessor: "amount",
        width: "10%",
        align: "left",
        style: {
          color: "black",
        },
      },
      {
        Header: "number of paying buyer",
        accessor: "number of paying buyer",
        width: "10%",
        align: "left",
        style: {
          color: "black",
        },
      },
      {
        Header: "payment conversion rate",
        accessor: "payment conversion rate",
        width: "10%",
        align: "left",
        style: {
          color: "black",
        },
      },
    ],

    rows: [
      {
        ranking: <Ranking name="1" />,
        members: (
          <MDBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Romina Hadid"],
              [team3, "Alexander Smith"],
              [team4, "Jessica Doe"],
            ])}
          </MDBox>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Летние мужские свободные льняные тонкие повседневные брюки большого размера
          </MDTypography>
        ),
        view: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2400
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1450,00
          </MDTypography>
        ),

        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),
        "number of paying buyer": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            54
          </MDTypography>
        ),

        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),

        "payment conversion rate": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            0.00%
          </MDTypography>
        ),
      },
      {
        ranking: <Ranking name="2" />,
        members: (
          <MDBox display="flex" py={1}>
            {avatars([
              [team2, "Romina Hadid"],
              [team4, "Jessica Doe"],
            ])}
          </MDBox>
        ),
        view: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2400
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Осенне-зимний свободный вязаный толстый повседневный свитер для пар большого размера с
            круглым вырезом и принтом тай-дай
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1450,00
          </MDTypography>
        ),
        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),
        "number of paying buyer": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            54
          </MDTypography>
        ),

        "payment conversion rate": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            0.00%
          </MDTypography>
        ),
      },
      {
        ranking: <Ranking name="3" />,
        members: (
          <MDBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Romina Hadid"],
              [team3, "Alexander Smith"],
              [team4, "Jessica Doe"],
            ])}
          </MDBox>
        ),
        view: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2400
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Летние мужские свободные льняные тонкие повседневные брюки большого размера
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1450,00
          </MDTypography>
        ),
        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),
        "number of paying buyer": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            54
          </MDTypography>
        ),

        "payment conversion rate": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            0.00%
          </MDTypography>
        ),
      },

      {
        ranking: <Ranking name="4" />,
        members: (
          <MDBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Romina Hadid"],
              [team3, "Alexander Smith"],
              [team4, "Jessica Doe"],
            ])}
          </MDBox>
        ),
        view: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2400
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Летние мужские свободные льняные тонкие повседневные брюки большого размера
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1450,00
          </MDTypography>
        ),
        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),
        "number of paying buyer": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            54
          </MDTypography>
        ),
        "payment conversion rate": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            0.00%
          </MDTypography>
        ),
      },

      {
        ranking: <Ranking name="5" />,
        members: (
          <MDBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Romina Hadid"],
              [team3, "Alexander Smith"],
              [team4, "Jessica Doe"],
            ])}
          </MDBox>
        ),
        view: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2400
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Летние мужские свободные льняные тонкие повседневные брюки большого размера
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1450,00
          </MDTypography>
        ),
        visitors: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            4100
          </MDTypography>
        ),
        "number of paying buyer": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            54
          </MDTypography>
        ),

        "payment conversion rate": (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            0.00%
          </MDTypography>
        ),
      },
    ],
  };
}
